import useLazyImgSrc from 'hooks/useLazyImgSrc'
import { styled } from 'styled-components'
import { OptImg } from 'utils/imageOptimization'
import * as React from 'react'
import theme from 'theme'
import Link from 'theme/atoms/Link'

type Props = {
  imgSrc: string | OptImg
  link: string
  name: string
}

export default function Card(props: Props) {
  const [ref, imgUrl] = useLazyImgSrc<HTMLImageElement>(props.imgSrc, 100)
  return (
    <Wrapper ref={ref} $imgSrc={imgUrl}>
      <Link to={props.link} className="link-wrapper">
        <div className="card-image">
          <div className="card-content">
            <div className="card-name">{props.name}</div>
          </div>
        </div>
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $imgSrc: string }>`
  > .link-wrapper {
    > .card-image {
      display: flex;
      background-image: url('${(p) => p.$imgSrc}');
      background-size: cover;
      background-position: center center;
      height: 11.25rem;
      width: 13.125rem;
      @media (min-width: ${theme.ms.MD}px) {
        width: 16.5625rem;
      }
      > .card-content {
        background-color: rgba(255, 255, 255, 90%);
        display: flex;
        height: 2.125rem;
        width: 100%;
        align-self: flex-end;
        > .card-name {
          ${theme.ty('r-base', null)}
          align-self: center;
          text-overflow: ellipsis;
          overflow-y: hidden;
          margin: 0 ${theme.spacing('xs')};
        }
      }
    }
  }
`
